var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container order-list" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            { staticClass: "lForm" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: true,
                    id: "searchForm",
                    model: _vm.searchForm,
                    "label-width": "70px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入商品名称",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.goodsName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "goodsName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "下单用户", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入下单用户",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.userInfo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "userInfo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.userInfo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人", prop: "postUserInfo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "收货人信息",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.postUserInfo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "postUserInfo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.postUserInfo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入订单编号",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "orderNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流编号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入物流编号",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.logisticsNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "logisticsNumber",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.logisticsNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型", prop: "orderType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择订单类型",
                            size: "small",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.orderType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "orderType", $$v)
                            },
                            expression: "searchForm.orderType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.platform_order_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间", prop: "createdTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          size: "small",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.createTime,
                          callback: function ($$v) {
                            _vm.createTime = $$v
                          },
                          expression: "createTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付时间", prop: "createdTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          size: "small",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.payTime,
                          callback: function ($$v) {
                            _vm.payTime = $$v
                          },
                          expression: "payTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("数据列表")]),
          _c("div", { staticClass: "btn-list tabclass" }, [
            _c(
              "div",
              {},
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectData },
                    model: {
                      value: _vm.radio1,
                      callback: function ($$v) {
                        _vm.radio1 = $$v
                      },
                      expression: "radio1",
                    },
                  },
                  [
                    _c(
                      "el-radio-button",
                      { attrs: { label: " ", border: "" } },
                      [
                        _vm._v(
                          "全部(" + _vm._s(_vm.statusCount.totalCount) + ")"
                        ),
                      ]
                    ),
                    _c("el-radio-button", { attrs: { label: "1" } }, [
                      _vm._v(
                        "待付款(" +
                          _vm._s(_vm.statusCount.waitingPayCount) +
                          ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "2" } }, [
                      _vm._v(
                        "待备货(" +
                          _vm._s(_vm.statusCount.waitingStockingCount) +
                          ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "3" } }, [
                      _vm._v(
                        "已备货(" + _vm._s(_vm.statusCount.stockedCount) + ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "4" } }, [
                      _vm._v(
                        "待发货(" +
                          _vm._s(_vm.statusCount.waitingDeliveryCount) +
                          ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "5" } }, [
                      _vm._v(
                        "已发货(" + _vm._s(_vm.statusCount.deliveredCount) + ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "6" } }, [
                      _vm._v(
                        "已收货(" + _vm._s(_vm.statusCount.receivedCount) + ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "7" } }, [
                      _vm._v(
                        "已取消(" + _vm._s(_vm.statusCount.closedCount) + ")"
                      ),
                    ]),
                    _c("el-radio-button", { attrs: { label: "99" } }, [
                      _vm._v(
                        "异常订单(" + _vm._s(_vm.statusCount.errorCount) + ")"
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.exportLoading,
                      icon: "el-icon-upload2",
                    },
                    on: { click: _vm.monthExport },
                  },
                  [_vm._v("导出本月订单数据")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.exportLoading,
                      icon: "el-icon-upload2",
                    },
                    on: { click: _vm.lotsExport },
                  },
                  [_vm._v("批量导出")]
                ),
              ],
              1
            ),
          ]),
          _c("orders-list-table", {
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columnCommon.config,
              typeStr: "logisticsOrder",
            },
            on: { tableSelectionChange: _vm.handleSelectionChange },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.searchForm.pageNo,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.searchForm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }